module.exports = __webpack_public_path__ + "img/sample1.80d379df.png";